module.exports = __webpack_public_path__ + "img/sz.a1d4fc8a.png";